{
    "SchedulereportLabel": "Schedule This Report:",
    "SchedulereportNotscheduledOptionLabel": "[Not Scheduled]",
    "SchedulereportOnceOptionLabel": "Once",
    "SchedulereportHourlyOptionLabel": "Hourly",
    "SchedulereportDailyOptionLabel": "Daily",
    "SchedulereportWeeklyOptionLabel": "Weekly",
    "SchedulereportMonthlyOptionLabel": "Monthly",
    "SchedulereportResetButtonLabel": "Reset",
    "SchedulereportPromptReset": "Are you sure that you want to reset the schedule?",
    "SchedulereportPromptButtonConfirmLabel": "Confirm",
    "SchedulereportPromptButtonCancelLabel": "Cancel",
    "NAME": "ReportScheduling",
    "ReportScheduling_SectionHeader": "Report Scheduling"
}